var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1844_26914)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.15405 15.613C12.282 15.613 15.6284 12.4356 15.6284 8.51621C15.6284 4.59677 12.282 1.41943 8.15405 1.41943C4.02607 1.41943 0.679688 4.59677 0.679688 8.51621C0.679688 12.4356 4.02607 15.613 8.15405 15.613Z",
    stroke: "#58A291",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5503 6.58057L7.20161 11.0967L4.6875 8.51605",
    stroke: "#58A291",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1844_26914"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16.3077,
    height: 15.4839,
    fill: "white",
    transform: "translate(0 0.77417)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/Check.e5f7a117e4e6cd3905419605145695e4.svg";
export { ForwardRef as ReactComponent };